import { render } from "./ProfileSpecialDays.vue?vue&type=template&id=f181c638"
import script from "./ProfileSpecialDays.vue?vue&type=script&lang=js"
export * from "./ProfileSpecialDays.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__